<script lang="ts">
  import DemoSignupModal from "@shared/svelte/Components/Layout/DemoHeader/DemoSignupModal.svelte";
  import FizzStyles from "../FizzStyles.svelte";
  import DemoHamburgerButton from "./DemoHeader/DemoHamburgerButton.svelte";
  import DemoProviLogoLink from "./DemoHeader/DemoProviLogoLink.svelte";
  import DemoSearchBar from "./DemoHeader/DemoSearchBar.svelte";
  import DemoLocationChooser from "./DemoHeader/DemoLocationChooser.svelte";

  import DemoNotificationsButton from "./DemoHeader/DemoNotificationsButton.svelte";
  import DemoCartButton from "./DemoHeader/DemoCartButton.svelte";

  let show: boolean = false;

  function showModal() {
    show = true;
  }

</script>

<FizzStyles>
  <DemoSignupModal bind:show />

  <header class="fizz-layout-header fizz-relative">
    <DemoHamburgerButton on:click={showModal} />
    <DemoProviLogoLink on:click={showModal} />
    <div data-grid-area="search" class="fizz-relative">
      <DemoSearchBar on:click={showModal} />
    </div>
    <div data-grid-area="user">
      <DemoLocationChooser on:click={showModal} />
    </div>
    <DemoNotificationsButton on:click={showModal} />
    <DemoCartButton on:click={showModal} />
  </header>
</FizzStyles>
